import React from 'react';

import SendIcon from '@mui/icons-material/Send';

import theme from '../../../../styles/theme';
import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const SendActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles(theme);

  return (
    <BaseActionButton
      styles={{
        width: '24px',
        height: '24px',
        color: theme.palette.grey[500],
        '&:hover': {
          color: theme.palette.primary.main,
        },
      }}
      {...props}>
      <SendIcon />
    </BaseActionButton>
  );
};

export default SendActionButton;
